const PaymentMethodsEnum = {
  ARCA: 'arca',
  STRIPE: 'stripe',
  IDRAM: 'idram',
};

export { PaymentMethodsEnum };
